import * as Sentry from "@sentry/react";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { ROUTES } from "#shared/routes";
import { useAnalytics } from "#shared/useAnalytics";

export const useLogout = () => {
  const analytics = useAnalytics();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    queryClient.clear();

    AccessTokenSingleton.getInstance().resetToken();
    analytics.reset();
    Sentry.setUser(null);
    navigate(ROUTES.login);
  }, [queryClient, navigate, analytics]);

  return { logout };
};
